{
  "eyebrow": "Escolhe o teu plano",
  "title": "O plano certo para a tua equipa.",
  "sub": "30 dias grátis em qualquer plano. Sem cartão de crédito. Cancela quando quiseres.",
  "bill": {
    "month": "Mensal",
    "year": "Anual",
    "save": "Poupa ~17%"
  },
  "fam": {
    "time": "Tempo e operações",
    "project": "Projetos e controlo de custos"
  },
  "compare": "Comparar todas as funcionalidades",
  "compareHide": "Ocultar comparação",
  "included": "Incluído",
  "select": "Escolher {{plan}}",
  "selected": "Selecionado",
  "recommended": "Mais popular",
  "pricePerMonth": "/ utilizador / mês",
  "pricePerYear": "/ utilizador / ano",
  "base": "base / mês",
  "admins": "2 administradores incluídos",
  "continueCta": "Continuar com {{plan}}",
  "continuePick": "Escolhe um plano para continuar",
  "catalogError": "Catálogo de preços indisponível. Tenta novamente para carregar os preços mais recentes.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Conformidade e registo simples",
    "timeProBest": "Operações de equipa",
    "projectBasicBest": "Projetos e controlo de custos",
    "projectProBest": "Gestão avançada de projetos",
    "feat": {
      "timeBasic": {
        "timeTracking": "Registo de tempo",
        "absencesHolidays": "Ausências e férias",
        "transport": "Registos de transporte",
        "workLocations": "Locais de trabalho e GPS",
        "mobileApp": "App móvel para trabalhadores em campo"
      },
      "timePro": {
        "everythingTime": "Tudo do Time Basic",
        "overtime": "Registo de horas extra",
        "scheduling": "Planeamento de turnos",
        "documents": "Documentos de colaboradores",
        "officeOps": "Funções de escritório (registo de atividade, correções)",
        "addonsAvailable": "Add-ons disponíveis: gestão de projetos, VTT",
        "internalMessaging": "Mensagens internas (chat da empresa)"
      },
      "projectBasic": {
        "everythingTime": "Tudo do Time Basic",
        "projects": "Projetos com controlo de custos",
        "extras": "Trabalho e materiais extra",
        "subcontractors": "Gestão de subcontratados",
        "checkInOut": "Check-in / check-out de trabalhadores",
        "internalMessaging": "Mensagens internas (chat da empresa)"
      },
      "projectPro": {
        "everythingAll": "Tudo do Time Pro + Project Basic",
        "projectTransport": "Transporte por projeto",
        "fullSuite": "Suite completa de produtividade",
        "prioritySupport": "Suporte prioritário",
        "internalMessaging": "Mensagens internas (chat da empresa)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Comparar todas as funcionalidades",
    "subtitle": "Tudo o que cada plano inclui, lado a lado.",
    "cat": {
      "timeAttendance": "Tempo e assiduidade",
      "projectCost": "Projeto e controlo de custos",
      "support": "Suporte"
    },
    "val": {
      "upTo4": "Até 4",
      "unlimited": "Ilimitado",
      "soon": "Em breve",
      "optional": "Opcional",
      "years5": "5 anos",
      "years10": "10 anos"
    },
    "row": {
      "mobileDesktop": "Aplicação móvel e desktop",
      "gpsCheckin": "Registo com um toque via GPS",
      "holidayAbsenceOvertime": "Férias, ausências e horas extra",
      "teamMembers": "Membros da equipa",
      "workLocations": "Locais de trabalho",
      "registrationsPerMonth": "Registos / utilizador / mês",
      "irregularMap": "Registo irregular no mapa",
      "expenseManagement": "Gestão de despesas",
      "employeeDocuments": "Documentos de funcionários",
      "openApi": "API aberta",
      "navigation": "Navegação para os locais de trabalho",
      "projectManagement": "Gestão de projetos (orçamento)",
      "subprojects": "Subprojetos",
      "subcontractorManagement": "Gestão de subcontratados",
      "extraWorkMaterials": "Trabalhos e materiais extra",
      "transportProjects": "Transporte associado a projetos",
      "fullSuite": "Suíte de produtividade completa",
      "prioritySupport": "Suporte prioritário",
      "schedulingMessaging": "Planeamento · Mensagens · Notificações",
      "languages12": "Disponível em 12 idiomas",
      "manualTransport": "Distância de transporte manual",
      "reportsExcel": "Relatórios e exportação para Excel",
      "frontendLocations": "Locais criados pelos utilizadores da app",
      "checkInWork": "Check-in/out@work (Bélgica)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Descrições e fotos de projetos",
      "dataStorage": "Armazenamento de dados"
    }
  }
}
